import React from "react";
import { useSelector } from "react-redux";
import { toAbsoluteUrl } from "_metronic/_helpers";
import Avatar from "app/popleads/components/ui-kit/Avatar";
import { BodyStrong, Caption } from "app/popleads/components/ui-kit/Text";
import { ASSISTANT_ORB } from "./assistantIcons";
import { assistantDisplayName } from "./assistantIdentity";

import styles from "./AssistantChatSkeleton.module.scss";

/**
 * The answer block before the answer arrives — same frame, same head row, so the real one lands
 * in place instead of pushing the layout around. Shimmer rather than a spinner because what is
 * loading is a block of text, and a shimmer says how much of it to expect.
 *
 * `plain` matches the chat item's: the CRM window's answers have no box and no head row, so
 * neither does the block standing in for one, and "Working on it" sits under the lines where the
 * answer's time will be.
 */
const ChatSkeleton = ({ plain = false }) => {
    const { user } = useSelector((state) => state.auth);

    const working = (
        <Caption className={styles.working}>
            Working on it
            <span className={styles.dot} />
            <span className={styles.dot} />
            <span className={styles.dot} />
        </Caption>
    );

    return (
        <article className={`${styles.answer} ${plain ? styles.plain : ""}`} role="status" aria-label="Working on it">
            {!plain && (
                <header className={styles.answerHead}>
                    <Avatar src={toAbsoluteUrl(ASSISTANT_ORB)} size={22} radius={11} />
                    <BodyStrong className={styles.answerName}>{assistantDisplayName(user)}</BodyStrong>
                    {working}
                </header>
            )}
            <div className={styles.lines} aria-hidden="true">
                <span className={styles.line} />
                <span className={styles.line} />
                <span className={styles.line} />
            </div>
            {plain && working}
        </article>
    );
};

export default ChatSkeleton;
